import { Injectable } from '@angular/core';
import { SpinnerComponent } from './spinner.component';

/**
 * Component for spinner
 */
@Injectable()
export class SpinnerService {
  private spinnerCache: any = new Set<SpinnerComponent>();

  /**
   * Registers the spinner to the cache
   */
  public _register(spinner: SpinnerComponent): void {
    this.spinnerCache.add(spinner);
  }

  /**
   * Removes the spinner to the cache
   */
  public _unregister(spinnerToRemove: SpinnerComponent): void {
    for (const spinner of this.spinnerCache) {
      if (spinner === spinnerToRemove) {
        this.spinnerCache.delete(spinner);
      }
    }
  }

  /**
   * Method to see if the spinner is currently showing
   */
  public isShowing(spinnerName: string): boolean | undefined {
    let showing: boolean;
    for (const spinner of this.spinnerCache) {
      if (spinner.name === spinnerName) {
        showing = spinner.show;
      }
    }
    return showing;
  }

  /**
   * Shows the spinner with the specified name
   */
  public show(spinnerName: string): void {
    for (const spinner of this.spinnerCache) {
      if (spinner.name === spinnerName) {
        spinner.show = true;
      }
    }
  }

  /**
   * Hides the spinner with the specified name
   */
  public hide(spinnerName: string): void {
    for (const spinner of this.spinnerCache) {
      if (spinner.name === spinnerName) {
        spinner.show = false;
      }
    }
  }

  /**
   * Shows the spinner with the specified group
   */
  public showGroup(spinnerGroup: string): void {
    for (const spinner of this.spinnerCache) {
      if (spinner.group === spinnerGroup) {
        spinner.show = true;
      }
    }
  }

  /**
   * Hides the spinner with the specified group
   */
  public hideGroup(spinnerGroup: string): void {
    for (const spinner of this.spinnerCache) {
      if (spinner.group === spinnerGroup) {
        spinner.show = false;
      }
    }
  }

  /**
   * Shows all spinners
   */
  public showAll(): void {
    for (const spinner of this.spinnerCache) {
      spinner.show = true;
    }
  }

  /**
   * Hides all spinners
   */
  public hideAll(): void {
    for (const spinner of this.spinnerCache) {
      spinner.show = false;
    }
  }
}
